import { useEditContext } from '@components/utils/contexts/EditContext';
import Icon from '@components/utils/icons/icon';
import InternalLink from '@components/utils/links/internalLink';
import { ROUTE_PRODUCT } from '@constants';
import { EmbedPostMessageAction } from '@lib/embed/enums';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { postMessageToEmbed } from '@lib/embed/utils/postMessageToEmbed';
import { IconButton } from '@lib/uikit';
import { useRouter } from 'next/router';
import { FC } from 'react';

export const ExitButton: FC = () => {
    const { query } = useRouter();
    const { isEditMode } = useEditContext();
    const { isEmbedContextLoading, isStoryBundle } = useEmbedContext();

    if (isEditMode || isEmbedContextLoading) return null;

    if (isStoryBundle) {
        return (
            <IconButton
                ariaLabel='Close'
                icon='close'
                color='white'
                size='medium'
                onClick={() =>
                    postMessageToEmbed(EmbedPostMessageAction.DIALOG_CLOSE)
                }
            />
        );
    }

    return (
        <InternalLink
            href={{ pathname: ROUTE_PRODUCT, query }}
            as={`/${query.product}`}
        >
            <Icon name='close' color='white' size='medium' />
        </InternalLink>
    );
};
